import { useState } from 'react';
import { toast } from 'sonner';
import { founderAdminApi } from '@/lib/founderApi';
import { errMsg } from '@/lib/digitalApi';

const input = 'border border-[#eae4d8] rounded-full px-4 py-2 text-sm bg-white';

export const TestCheckoutCard = () => {
  const [form, setForm] = useState({ first_name: '', email: '' });
  const [busy, setBusy] = useState(false);
  const go = async (ev) => {
    ev.preventDefault();
    setBusy(true);
    try {
      const r = await founderAdminApi.testCheckout(form);
      window.location.href = r.checkout_url;
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <form onSubmit={go} className="mt-8 bg-white border border-dashed border-[#C8A15A] rounded-xl p-5" data-testid="fb-test-checkout-form">
      <div className="text-[10px] tracking-[0.22em] uppercase text-[#C8A15A]">Preview test purchase · Stripe test mode only</div>
      <p className="mt-2 text-xs text-[#666]">Use card 4242 4242 4242 4242 and a test inbox (e.g. name@resend.dev). Never a real customer email.</p>
      <div className="mt-4 flex flex-wrap gap-2">
        <input required placeholder="First name" value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} className={input} data-testid="fb-test-first-name-input" />
        <input required type="email" placeholder="test@resend.dev" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} data-testid="fb-test-email-input" />
        <button disabled={busy} className="text-xs uppercase tracking-[0.14em] px-5 py-2 bg-[#111] text-white rounded-full" data-testid="fb-test-checkout-button">Start Test Checkout</button>
      </div>
    </form>
  );
};
